<template>
    <div class="position-fixed" style="bottom: 20px; right: 20px;">
        <router-link :to="to" class="btn btn-lg px-4 py-3 shadow" :class="this.class">
            <slot />
        </router-link>
    </div>
</template>

<script>
export default {
    name: "OwlFloatingButton",
    props: {
        to: String,
        class: {
            type: String,
            default: 'bg-gradient-success',
        },
    }
}
</script>